export const LEGAL_INFO = {
  companyName: 'EbiTrade',
  website: 'ebitrade.com',
  privacyEmail: 'team@elecsotech.com',
  legalEmail: 'team@elecsotech.com',
  jurisdiction: '[país o estado de la jurisdicción]',
  minimumAge: 18,
  lastUpdated: '1 de octubre de 2026',
};
